module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-powered-ff34f5fa7efda37e448d846f629b5537.svg";